/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type * as DTO from '../index';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AreaAcademyControllerService {
	constructor(public readonly httpRequest: BaseHttpRequest) {}

	/**
	 * GET A ROOT FOLDER
	 * @returns DTO.AreaAcademyFolderDTO OK
	 * @throws ApiError
	 */
	public getRootAcademyFolder(): CancelablePromise<Array<any>> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/academies',
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	/**
	 * GET A SINGLE FOLDER
	 * @returns DTO.AreaAcademyFolderDTO OK
	 * @throws ApiError
	 */
	public getSingleFolder(id: string): CancelablePromise<Array<any>> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/academies/{id}',
			path: {
				id: id,
			},
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	/**
	 * SEARCH
	 * @returns DTO.AreaObjectSearchRequestDTO OK
	 * @throws ApiError
	 */
	public searchQuery(
		requestBody: DTO.AreaObjectSearchRequestDTO
	): CancelablePromise<Array<any>> {
		return this.httpRequest.request({
			method: 'POST',
			url: '/academies/search',
			body: requestBody,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	/**
	 * CREATE NEW OBJECT
	 * @param requestBody
	 * @returns any OK
	 * @throws ApiError
	 */
	public postFolder(
		requestBody?: DTO.AreaObjectCreateRequestDTO
	): CancelablePromise<any> {
		return this.httpRequest.request({
			method: 'POST',
			url: '/academies',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	/**
	 * EDIT FOLDER NAME
	 * @param requestBody
	 * @returns any OK
	 * @throws ApiError
	 */
	public editFolderName(
		id: string,
		requestBody: DTO.AreaEditObjectDTO
	): CancelablePromise<any> {
		return this.httpRequest.request({
			method: 'PUT',
			url: '/academies/{id}',
			path: {
				id: id,
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	/**
	 * DELETE FOLDER
	 * @param requestBody
	 * @returns any OK
	 * @throws ApiError
	 */
	public deleteFolder(id?: DTO.AreaDeleteFolderDTO): CancelablePromise<any> {
		return this.httpRequest.request({
			method: 'DELETE',
			url: '/academies/{id}',
			// body: requestBody,
			path: {
				id: id,
			},
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	/**
	 * ADVANCED SEARCH FOR FOLDERS
	 * @returns DTO.AreaAcademyFolderDTO OK
	 * @throws ApiError
	 */
	public advancedSearch(
		requestBody: DTO.AcademyAdvancedSearchRequestDTO
	): CancelablePromise<Array<any>> {
		return this.httpRequest.request({
			method: 'POST',
			url: '/academies/advancedSearch',
			path: {},
			body: requestBody,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}

	public downloadRentalDocuments(
		query: { nomeNoleggiatore: string; tipoCliente: string }
	): CancelablePromise<any> {
		return this.httpRequest.request({
			method: 'GET',
			url: '/academies/documentation',
			query,
			errors: {
				401: `Not Authorized`,
				403: `Not Allowed`,
			},
		});
	}
}
